import { MenuItem } from '@material-ui/core';
import PublicOutlinedIcon from '@material-ui/icons/PublicOutlined';
import { useGlobalNodeSettings } from '../../sidebars/globalNodeSettingsContext';

const GLOBAL_INDICATOR_STYLE = {
  marginLeft: 8,
  padding: '2px 8px',
  borderRadius: 999,
  border: '1px solid #047857',
  backgroundColor: '#ECFDF5',
  color: '#047857',
  fontSize: 11,
  fontWeight: 600,
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
  display: 'inline-block',
  verticalAlign: 'middle'
};

/**
 * Green "Global" chip — visible only when the node is already a Global Node.
 */
export function GlobalNodeIndicator({ isGlobal = false }) {
  const { isAiWorkflow } = useGlobalNodeSettings();
  if (!isAiWorkflow || !isGlobal) return null;

  return (
    <span className="global-node-indicator" title="Global Node" style={GLOBAL_INDICATOR_STYLE}>
      Global
    </span>
  );
}

/**
 * Opens Global Node settings drawer for this node (AI workflows only).
 */
export function useGlobalNodeMenu(nodeId, editable = true) {
  const { isAiWorkflow, openForNode } = useGlobalNodeSettings();

  const openGlobalSettings = e => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (!editable) return;
    openForNode?.(nodeId);
  };

  return {
    showGlobalMenuItem: Boolean(isAiWorkflow),
    openGlobalSettings
  };
}

/**
 * ⋮ menu item: "Convert the node into Global Node"
 */
export function GlobalNodeMenuItem({ nodeId, editable = true, onClick }) {
  const { showGlobalMenuItem, openGlobalSettings } = useGlobalNodeMenu(
    nodeId,
    editable
  );

  if (!showGlobalMenuItem) return null;

  return (
    <MenuItem
      disabled={!editable}
      onClick={e => {
        openGlobalSettings(e);
        onClick?.(e);
      }}
    >
      <PublicOutlinedIcon
        fontSize="small"
        style={{ marginRight: '8px', color: '#047857' }}
      />
      Convert the node into Global Node
    </MenuItem>
  );
}

/** @deprecated Use GlobalNodeIndicator + GlobalNodeMenuItem */
export default function GlobalNodeButton() {
  return null;
}
